import { useState, useEffect, useCallback } from 'react';
import { CountContext } from '../Contexts';
export function CountProvider({ children }) {
    const [count, setCount] = useState(0);

    return (
        <CountContext.Provider value={{ count, setCount }}>
            {children}
        </CountContext.Provider>
    );
}
